import React from 'react';
import CatalogFilterChoiceListItem from './CatalogFilterChoiceListItem';

const CatalogFilterChoiceList = ({currentFilter}) => {
	return <CatalogFilterChoiceListItem filter={currentFilter}/>;
};

export default CatalogFilterChoiceList;
